import { IProjectAssetMapping } from '../../interfaces/iproject-asset-mapping';
import { Asset } from '../asset';
import { CostCenter } from '../cost-center';
import { Project } from '../project';

export class ProjectAssetMappingBase {
  ProjectAssetMappingId: number;
  AssetId: number | null;
  ProjectId: number | null;
  PercentAllocation: number | null;
  IsConstructedAsset: boolean | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  CostCenterId: number | null;

  Asset?: Asset;
  CostCenter?: CostCenter;
  Project?: Project;

  constructor(item?: IProjectAssetMapping) {
    if (item) {

      this.ProjectAssetMappingId = item.ProjectAssetMappingId;
      this.AssetId = item.AssetId;
      this.ProjectId = item.ProjectId;
      this.PercentAllocation = item.PercentAllocation;
      this.IsConstructedAsset = item.IsConstructedAsset;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.CostCenterId = item.CostCenterId;

      this.Asset = new Asset(item.Asset);
      this.CostCenter = new CostCenter(item.CostCenter);
      this.Project = new Project(item.Project);
    }
  }
}